module.exports = __webpack_public_path__ + "img/mnisw.1ba516c7.webp";